import { ApiResult, request, toQuery } from "./system";

export interface DashboardStat {
  label: string;
  value: number;
  change: number;
  up: boolean;
}

export interface DashboardTrendPoint {
  time: string;
  value: number;
}

export interface DashboardAnnouncement {
  id: number | string;
  title: string;
  date: string;
  isTop?: boolean;
}

export interface DashboardTodo {
  id: number | string;
  type: string;
  title: string;
  desc: string;
  time: string;
  iconBg: string;
  iconColor: string;
  path?: string;
}

export interface HomeDashboardData {
  stats: DashboardStat[];
  trend: DashboardTrendPoint[];
  announcements: DashboardAnnouncement[];
  todos: DashboardTodo[];
}

export interface OperationMetric {
  name: string;
  value: number;
  change: number;
  unit: string;
}

export interface OperationDashboardData {
  coreMetrics: OperationMetric[];
  contactTrend: Array<{ date: string; total: number; completed: number }>;
  feeIncomeTrend: Array<{ date: string; amount: number }>;
  activityRanking: Array<{ name: string; signUpCount: number; checkInRate: number }>;
  merchantRanking: Array<{ name: string; writeOffCount: number; writeOffAmount: number }>;
  realtimeWriteOffs: Array<{ merchantName: string; memberName: string; amount: number; time: string }>;
  date?: string;
}

export async function getHomeDashboard(range = "today") {
  const res = await request<ApiResult<HomeDashboardData>>(`/api/admin/dashboard/home${toQuery({ range })}`);
  return res.data;
}

export async function getOperationDashboard(range = "7d") {
  const res = await request<ApiResult<OperationDashboardData>>(`/api/admin/dashboard/operation${toQuery({ range })}`);
  return res.data;
}
